import { ERROR_CODE } from '../config/errorcode';
/**
 * 这个函数的作用就是，简化根据stat.code判断是否成功的逻辑，不需要在多个页面写大量if else
 * @param res          后台返回的原始res数据
 * @returns {Promise}
 */
export const responseHandler = res => {
  let originData = res.data || {};
  //格式1：result:ok,code:113099
  originData.code ? (originData.code = originData.code + '') : '';
  if (
    originData.hasOwnProperty('result') &&
    originData.hasOwnProperty('code')
  ) {
    return new Promise((resolve, reject) => {
      if (originData.code == ERROR_CODE.SUCCESS) {
        resolve(originData.data);
      } else if (
        originData.code === ERROR_CODE.TOKEN_INVALID ||
        ERROR_CODE.LOGOUT_CODE.indexOf(originData.code) !== -1
      ) {
        //token过期直接跳转到登录页
        //location.href = '/login.html';
        ccutils.logout();
      } else if (ERROR_CODE.REFRESH_CODE.indexOf(originData.code) !== -1) {
        //location.reload();
        console.error(originData.result);
      } else {
        console.error(originData.result);
        reject(originData); //返回整个错误体
      }
    });
  } else if (
    originData.hasOwnProperty('result') &&
    originData.hasOwnProperty('data')
  ) {
    return new Promise((resolve, reject) => {
      if (ERROR_CODE.TOKEN_INVALID_LIST.indexOf(originData.result) !== -1) {
        //location.href = '/login.html';
        ccutils.logout();
      }
      if (originData.result === ERROR_CODE.OK) {
        resolve(originData.data);
      } else {
        reject(originData.result); //只返回相关的错误信息部分
      }
    });
  } else if (Array.isArray(originData)) {
    //格式2：[]
    return new Promise(resolve => {
      resolve(originData);
    });
  } else if (
    originData.hasOwnProperty('isError') &&
    originData.hasOwnProperty('data')
  ) {
    return new Promise((resolve, reject) => {
      if (originData.hasOwnProperty('code')) {
        if (ERROR_CODE.LOGOUT_CODE.indexOf(originData.code) !== -1) {
          //location.href = '/login.html';
          ccutils.logout();
        } else if (ERROR_CODE.REFRESH_CODE.indexOf(originData.code) !== -1) {
          //location.reload();
          console.error(originData.result);
        }
      }
      if (originData.isError) {
        reject(originData.message); //只返回相关的错误信息部分
      } else {
        resolve(originData.data);
      }
    });
  } else {
    if (originData.hasOwnProperty('code')) {
      if (ERROR_CODE.LOGOUT_CODE.indexOf(originData.code) !== -1) {
        //location.href = '/login.html';
        ccutils.logout();
      } else if (ERROR_CODE.REFRESH_CODE.indexOf(originData.code) !== -1) {
        //location.reload();
        console.error(originData.result);
      }
    }
    return Promise.resolve(originData);
  }
};
